import React, { useState, useRef, useEffect } from 'react';
import styles from './style.module.css';

const dayOptions = [
  { value: 'monday', label: 'Segunda-feira' },
  { value: 'tuesday', label: 'Terça-feira' },
  { value: 'wednesday', label: 'Quarta-feira' },
  { value: 'thursday', label: 'Quinta-feira' },
  { value: 'friday', label: 'Sexta-feira' },
  { value: 'saturday', label: 'Sábado' },
  { value: 'sunday', label: 'Domingo' },
];

const DaySelector = ({ selectedDays = [], handleDayChange = () => {}, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (value, e) => {
    e.stopPropagation();
    if (!handleDayChange) return;
    
    const newSelectedDays = selectedDays.includes(value)
      ? selectedDays.filter(day => day !== value)
      : [...selectedDays, value];
    
    handleDayChange(newSelectedDays);
  };

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getSelectedText = () => {
    if (!selectedDays || selectedDays.length === 0) return "Selecione os dias";
    if (selectedDays.length === 1) {
      const selected = dayOptions.find(opt => opt.value === selectedDays[0]);
      return selected ? selected.label : "1 dia selecionado";
    }
    return `${selectedDays.length} dias selecionados`;
  };

  const handleLabelClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.selectorContainer} ref={wrapperRef}>
      {label && <label htmlFor="daySelect">{label}</label>}
      <div className={isOpen ? `${styles.selectWrapper} ${styles.active}` : styles.selectWrapper}>
        <div className={styles.selectedDisplay} onClick={toggleDropdown}>
          <span>{getSelectedText()}</span>
          <span className={styles.arrow}>{isOpen ? "▲" : "▼"}</span>
        </div>
        <div className={styles.checkboxList}>
          {dayOptions.map((option) => (
            <label 
              key={option.value} 
              className={styles.checkboxItem}
              onClick={handleLabelClick}
            >
              <input
                type="checkbox"
                checked={selectedDays?.includes(option.value)}
                onChange={(e) => handleCheckboxChange(option.value, e)}
              />
              <span>{option.label}</span>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DaySelector; 